export const filter = {
  period: 'Период',
  period_buy: 'Период покупки',
  search: 'Поиск',
  show_result: 'Показать',
  name: 'Наименование',
  mcc: 'MCC',
  mnc: 'MNC'
};
